module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "response-container"
  }, [_c('h1', [_vm._v("ICEGATE 05 API Response")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SB No (6845161)"), _c('b-badge', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "light",
      "title": "Shipping Bill Number"
    }
  }, [_vm._v("?")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sbNo),
      expression: "sbNo"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "e.g. 6845161"
    },
    domProps: {
      "value": (_vm.sbNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sbNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("SB Date(02042016) "), _c('b-badge', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "light",
      "title": "Format: DDMMYYYY"
    }
  }, [_vm._v("?")])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sbDt),
      expression: "sbDt"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "e.g. 02042016"
    },
    domProps: {
      "value": (_vm.sbDt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sbDt = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('b-col', {
    staticClass: "align-self-end",
    attrs: {
      "md": "3"
    }
  }, [(_vm.sbNo && _vm.sbDt) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getAllICEGATE05Func()
      }
    }
  }, [_vm._v("\n           Fetch\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.errorMsg) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": ""
    }
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.sbNo && _vm.sbDt) && (_vm.getAllICEGATE05.sbNo)) ? _c('b-card', {
    staticClass: "mt-4 shadow"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("SB No:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getAllICEGATE05.sbNo || (_vm.getAllICEGATE05.sbNo) || _vm.sbNo))]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "title": "Copy SB No"
    },
    on: {
      "click": function($event) {
        _vm.copyToClipboard(_vm.getAllICEGATE05.sbNo || (_vm.getAllICEGATE05.data && _vm.getAllICEGATE05.data.sbNo))
      }
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("SB Date:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getAllICEGATE05.sbDt || (_vm.getAllICEGATE05.sbDt) || _vm.sbDt))])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("Unit of Quantity:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE05.unitOfQt)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE05.unitOfQt || 'N/A') + "\n          ")])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("Nature of Cargo:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE05.natureOfCargo)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE05.natureOfCargo || 'N/A') + "\n          ")])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("No of Packages:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE05.noOfPkgs)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE05.noOfPkgs || 'N/A') + "\n          ")])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("Port of Destination:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE05.portOfDest)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE05.portOfDest || 'N/A') + "\n          ")])]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b', [_vm._v("Gross Quantity:")]), _vm._v(" "), _c('span', {
    class: {
      'text-danger': !(_vm.getAllICEGATE05.grossQt)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getAllICEGATE05.grossQt || 'N/A') + "\n          ")])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && (_vm.sbNo && _vm.sbDt) && !(_vm.getAllICEGATE05.sbDt)) ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("\n      No LEO Date found for this SB No and Date.\n    ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32db68e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/ICEGATE05_ResponseDisplay.vue
// module id = 2506
// module chunks = 0